export default defineNuxtRouteMiddleware((to, from) => {
  // Only track when navigating TO a settings page
  if (to.path.startsWith("/settings") && !from.path.startsWith("/settings")) {
    const navigationStore = useNavigationStore();
    navigationStore.setPreviousRoute(from.fullPath);
  }
});
